import React from "react";
import MaskedInput from "react-text-mask";
import { InputStyle } from "./input.style";

const Core = props => (
	<div className={props.type === "radio" ? null : "input-group mb-2"}>
		{typeof props.icon === "undefined" ? null : (
			<Icon content={props.icon} />
		)}
		<InputStyle
			checked={props.checked}
			disabled={props.disabled}
			maxLength={props.maxLength}
			pattern={props.pattern}
			max={props.max}
			min={typeof props.min !== "undefined" ? props.min : "1900-01-01"}
			error={props.error}
			type={props.type}
			value={props.value}
			placeholder={props.placeholder}
			onChange={props.onChange}
			name={props.name}
			bsSize={props.size}
			id={props.id}
			rows={props.rows}
			autoComplete="off"
		/>
	</div>
);

const Icon = props => (
	<div className="input-group-prepend">
		<div className="input-group-text">{props.content}</div>
	</div>
);

class Input extends React.Component {
	render() {
		return (
			<React.Fragment>
				{typeof this.props.mask === "undefined" ? (
					<Core {...this.props} />
				) : (
					<MaskedInput
						{...this.props}
						placeholder={this.props.placeholder}
						mask={this.props.mask}
						guide
						render={(ref, props) => (
							<div className="input-group mb-2">
								{typeof this.props.icon ===
								"undefined" ? null : (
									<Icon content={this.props.icon} />
								)}
								<InputStyle
									autoComplete="off"
									innerRef={ref}
									{...props}
								/>
							</div>
						)}
					/>
				)}
			</React.Fragment>
		);
	}
}

export default Input;
